export const generateOrgKey = (original: string) => {
  // Ignore non-word characters
  let orgKey = original.replace(/[^\w\s]/gi, '');
  // Spaces to underscores
  orgKey = orgKey.replace(/[\s]+/g, '_');
  // uppercase to lowercase
  return orgKey.replace(/[A-Z]/g, (match) => match.toLowerCase());
};
